const stringHelper = {
    isNumber(value) {
        const engValue = this.getEnglishNum(value)
        if (/^[0-9۰-۹]*$/.test(engValue)) {
            return true
        }
        return false;
    },
    isMobile(value) {
        const engValue = this.getEnglishNum(value)
        if (
            this.isNumber(engValue) && 
            engValue.startsWith("09") && engValue.length === 11) {
            return true
        }
        return false;
    },
    isFarsi(value) {
        if (!value) {
            return false
        }

        value = value.replace(/\s+/g, '');
        if (/^[آ-یء\s]+$/.test(value)) {
            return true;
        }
        return false;
    },
    getFarsiNum(str) {
        if (!str) {
            return str
        };
        str = str.toString().replace(/0/g, '۰');
        str = str.toString().replace(/1/g, '۱');
        str = str.toString().replace(/2/g, '۲');
        str = str.toString().replace(/3/g, '۳');
        str = str.toString().replace(/4/g, '۴');
        str = str.toString().replace(/5/g, '۵');
        str = str.toString().replace(/6/g, '۶');
        str = str.toString().replace(/7/g, '۷');
        str = str.toString().replace(/8/g, '۸');
        str = str.toString().replace(/9/g, '۹');
        return str;
    },
    getEnglishNum(str) {
        if (!str) {
            return str
        };
        str = str.toString().replace(/۰/g, '0');
        str = str.toString().replace(/۱/g, '1');
        str = str.toString().replace(/۲/g, '2');
        str = str.toString().replace(/۳/g, '3');
        str = str.toString().replace(/۴/g, '4');
        str = str.toString().replace(/۵/g, '5');
        str = str.toString().replace(/۶/g, '6');
        str = str.toString().replace(/۷/g, '7');
        str = str.toString().replace(/۸/g, '8');
        str = str.toString().replace(/۹/g, '9');
        return str;
    },
    
  currencyFormat(str) {
    if (!str) {
        return this.getFarsiNum(str)
    }
    return this.getFarsiNum(str.toLocaleString('fa-IR'))
  },

  hasValue(value) {
    if (typeof value !== 'string') return false;
    const trimmed = value.trim().toLowerCase();
    return trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined';
  },
};

export default stringHelper;